import { Button, Dialog, Text, VStack } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../../../features/track';
import { urlBuilder } from '../../../../../Shared/urlBuilder';

type Props = {
  legacyGoalId: number;
  name: string;
  isEditable: boolean;
  hasPendingPortfolioChangeRequest: boolean;
};

const PortfolioChangeReminderModal: React.FC = () => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Button variant="textPrimary">Change</Button>
      </Dialog.Trigger>
      <Dialog.Content size="large" css={{ padding: 'space.400' }}>
        <Dialog.Title>A portfolio change has already traded for this account today</Dialog.Title>
        <Dialog.Description>
          Changing this portfolio again could violate pattern day trading rules. Please try again later.
        </Dialog.Description>
        <Dialog.Close asChild={true}>
          <Button css={{ mt: 'space.200' }}>Close</Button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog>
  );
};

export const PortfolioStrategyRow: React.FC<Props> = ({
  legacyGoalId,
  name,
  isEditable,
  hasPendingPortfolioChangeRequest,
}) => {
  const editableLink = isEditable ? (
    <SambaAutoLink
      to={urlBuilder.appGoalsEditPortfolioStrategy.absolute({
        goalId: legacyGoalId,
        return_to: window.location.pathname,
      })}
      onClick={() => {
        trackClick({ name: 'ChangePortfolioStrategy', flow: 'AccountOverview', location: 'PortfolioStrategyCard' });
      }}
    >
      Change
    </SambaAutoLink>
  ) : null;

  return (
    <VStack>
      <Text variant="text200">{name}</Text>
      {isEditable && hasPendingPortfolioChangeRequest ? <PortfolioChangeReminderModal /> : editableLink}
    </VStack>
  );
};
